import clsx from "clsx";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatAttemptMessage({ message, settings }: MessageProps) {
  const { showTime } = settings;

  const isSuccesAttemp = message.message.payload === true;

  return (
    <div className={clsx("w-full text-[#e66dec]")}>
      {showTime && <Time date={message.date} />} <span>{getPlayerContent(message)}</span>{" "}
      {message.message.content}
      <span className={clsx("px-2", isSuccesAttemp ? "text-[#4EE966]" : "text-[#F74B4B]")}>
        &#9658; {isSuccesAttemp ? "Удачно" : "Неудачно"}
      </span>
    </div>
  );
}
